import { identity, pickBy } from "ramda";

export function queryParams(args: Record<string, string>) {
  const params = new URLSearchParams(pickBy(identity, args)).toString();
  return params ? `?${params}` : "";
}

export function linkToInventory() {
  return "/inventory";
}

// Requests
export function linkToInventoryMoveRequests() {
  return `${linkToInventory()}/move-requests`;
}

export function linkToInventoryMoveRequest(moveRequestId = ":moveRequestId") {
  return `${linkToInventory()}/move-request/${moveRequestId}`;
}

export function linkToFulfillInventoryMoveRequest(moveRequestId?: string) {
  return `${linkToInventoryMoveRequest(moveRequestId)}/fulfill`;
}

export function linkToInventoryMoveRequestOverview(moveRequestId?: string) {
  return `${linkToInventoryMoveRequest(moveRequestId)}/overview`;
}

export function linkToInventoryMoveRequestNew() {
  return `${linkToInventoryMoveRequests()}/new`;
}

// Receive
export function linkToBulkReceive() {
  return `${linkToInventory()}/bulk-receive`;
}

// Stock take (bulk)
export function linkToBulkStocktake() {
  return `${linkToInventory()}/bulk-stocktake`;
}

// Stock take
export function linkToInitiateStockTake(locationId?: string) {
  const params = queryParams({
    locationId,
  });

  return `${linkToInventory()}/initiate-stocktake${params}`;
}

export function linkToStockTake(id = ":stockTakeId") {
  return `${linkToInventory()}/stocktake/${id}`;
}

export function linkToStockTakeReview(id = ":stockTakeId") {
  return `${linkToStockTake(id)}/review`;
}

export function linkToStockTakeHistory({
  locationId,
  startDate,
  endDate,
}: {
  locationId?: string;
  startDate?: string;
  endDate?: string;
} = {}) {
  const params = queryParams({
    locationId,
    startDate,
    endDate,
  });

  return `${linkToInventory()}/stocktake-history${params}`;
}

export function linkToHistoricStockTakeOverview(id = ":stockTakeId") {
  return `${linkToStockTakeHistory()}/${id}`;
}

// History

export function linkToInventoryAudit({
  locationId,
  startDate,
  endDate,
}: {
  locationId?: string;
  startDate?: string;
  endDate?: string;
} = {}) {
  const params = queryParams({
    locationId,
    startDate,
    endDate,
  });

  return `${linkToInventory()}/audit${params}`;
}
